import React, { Children, useRef } from "react";
import { addFaq, updateFaq } from "../../actions/utilitiesAction";
import constant from "../../constant";
import QualificationLists from "../../component/jobs/QualificationList";
import { archiveEducationQualification, createEducationQualification, createFunctionalarea, createRole, updateEducationQualification, updateFunctionalarea, updateRole } from "../../actions/JobsAction";
import QuestionLists from "../../component/jobs/QuestionList";
import RoleLists from "../../component/jobs/RoleList";
import AddRoles from "../../component/jobs/AddRole";
import AddFunctionalAreas from "../../component/jobs/AddFunctionalArea";
import { useNavigate } from "react-router-dom";

const EditFunctionalArea = () => {
    const navigation = useNavigate();
    const [response, setResponse] = React.useState({})
    const [showMsg, setShowMsg] = React.useState(false)

    const onSubmit = (model) => {
        if (model.type === 'ADD') {
            // createFunctionalarea(model).then((res) => {
            //     setResponse(res)
            //     setShowMsg(true)
            //     setTimeout(() => {
            //         setShowMsg(false)
            //     }, 7000)
            // }).catch((err) => {
            //     alert(err)
            // })
        } else {
            updateFunctionalarea(model).then((res) => {
                if (res.status) {
                    navigation(constant.component.listFunctionalArea.url + "?p=" + model.pageno)
                }
                else {
                    setResponse(res)
                    setShowMsg(true)
                    setTimeout(() => {
                        setShowMsg(false)
                    }, 7000)
                }
            }).catch((err) => {
                alert(err)
            })
        }

    }


    return (
        <React.Fragment>
            <AddFunctionalAreas onSubmit={(data) => onSubmit(data)} response={response} showMsg={showMsg} title="Update FuncyionalArea" />
        </React.Fragment>
    )
}

export default EditFunctionalArea;